import { Link } from "react-router-dom";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import ServicesSection from "../features/services/ServicesSection";
import useSeo from "../hooks/useSeo";

export default function ServicesPage() {
  useSeo({
    title: "სერვისები | Thermo Fix",
    description:
      "ნახე Thermo Fix-ის ყველა სანტექნიკური სერვისი: გათბობის მონტაჟი, მილების რემონტი, კანალიზაციის გაწმენდა, ქვაბის დიაგნოსტიკა და სხვა.",
    path: "/services",
    keywords:
      "სანტექნიკის მომსახურება თბილისი, მილების შეკეთება, გათბობის მონტაჟი, კანალიზაციის გაწმენდა, boiler repair",
    image: "/boiler.png",
  });

  return (
    <div className="relative overflow-hidden">
      <Header />

      <section className="mx-auto w-full max-w-6xl px-6 pb-2 pt-16">
        <div className="mb-8 flex items-center justify-between gap-4">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#5481be] dark:text-[#89abe0]">
              სრული სერვისები
            </p>
            <h1 className="mt-3 text-3xl font-bold text-[#0f2748] dark:text-[#e5efff] md:text-5xl">
              ყველა სანტექნიკური სერვისი
            </h1>
          </div>
          <Link
            to="/"
            className="rounded-2xl border border-[#d4e2f5] px-5 py-2 text-sm font-semibold text-[#24466f] transition hover:bg-white dark:border-[#365073] dark:text-[#c9dcf8] dark:hover:bg-[#182b44]"
          >
            უკან დაბრუნება
          </Link>
        </div>
      </section>

      <ServicesSection />
      <Footer />
    </div>
  );
}
